import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'GroupCardContainer'

    static propTypes = {
      group: PropTypes.object.isRequired,
      handleNameSet: PropTypes.func.isRequired,
    }

    state = {
      name: this.props.group.name,
    }

    handleNameChange = (_e, { value: name }) => {
      this.setState({ name })
    }

    handleNameSubmit = () => {
      const { handleNameSet } = this.props
      const { name } = this.state

      handleNameSet(name)
    }

    render() {
      return (
        <WrappedComponent
          handleNameChange={this.handleNameChange}
          handleNameSubmit={this.handleNameSubmit}
          {...this.props}
          {...this.state}
        />
      )
    }
  }

  return Container
}
